import { useI18n } from "@wato/i18n/react";
import { useWorkspace } from "../features/workspace/WorkspaceContext";
import { BlockedState } from "./BlockedState";

/** FB2-51: a permission block is a reason + a next step (who can grant access), never a bare "forbidden". */
export function NoAccessState({
  reason,
  title,
}: {
  readonly reason: string;
  /** OWN-333: a module-off page names the module instead of the generic permission title. */
  readonly title?: string;
}) {
  const { t } = useI18n();
  const { workspace } = useWorkspace();
  return (
    <BlockedState
      title={title ?? t("blocked.noAccess.title")}
      reason={reason}
      ctaLabel={t("blocked.noAccess.cta")}
      ctaTo={`/w/${workspace.id}/settings/team`}
    />
  );
}
